import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { Except } from "type-fest";
import { SecondaryButton } from "../Common/SecondaryButton";

interface PastBookingWarningModalProps {
    isOpen: boolean;
    onClose?: () => void;
    onContinue: () => void;
}

export const PastBookingWarningModal = ({ isOpen, onClose, onContinue }: PastBookingWarningModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <PastBookingWarningModalContent onClose={onClose} onContinue={onContinue} />
    </Modal>
);

export const PastBookingWarningModalContent = ({
    onClose,
    onContinue,
}: Except<PastBookingWarningModalProps, "isOpen">) => (
    <>
        <Modal.Header>Warning: Past Reservation</Modal.Header>
        <Modal.Body className="flex justify-center">
            You are about to modify a reservation for a past event. Are you sure you want to continue?
        </Modal.Body>
        <Modal.Footer className="flex justify-end">
            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            <SubmitButton onClick={onContinue}>Continue</SubmitButton>
        </Modal.Footer>
    </>
);
